import store from "../..";
import { service } from "@/api/service ";
import { toastError, toast } from "@/components/custom/Toast";
const state = {
  paidWages: [],
  paidWage: {},
  pagination: {},
};
const getters = {
  PaidWagesListGet: (state) =>
    state.paidWages.map((obj) =>
      obj.date === null ? { ...obj, wage: "No" } : { ...obj, wage: "Yes" }
    ),
  paidWageGet: (state) => state.paidWage,
  paginationGet: (state) => state.pagination,
  // coursesListGet: (state) =>
  //   state.courses.map((obj) =>
  //     obj.internalORexternal === 0
  //       ? { ...obj, internalORexternal: "external" }
  //       : { ...obj, internalORexternal: "internal" }
  //   ),
};
const actions = {
  getPaidWages({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    service.getFun(`paid-wages?page=${page}`).then(
      (obj) => {
        var result = obj.data.data;
        const pageresult = {
          currentPage: obj.data.current_page,
          lastPage: obj.data.last_page,
          itemsPerPage: obj.data.per_page,
          total: obj.data.total,
        };
        commit("paidWagesListSet", result);
        commit("setPagination", pageresult);
      },
      (error) => {
        // console.log("courses..." + error);
        toastError(error);
      }
    );
  },
  addPaidWage({ commit }, payload) {
    const data = service.deleteNullValues(payload);
    service
      .postFun(data, `paid-wages`, null, {
        action: "getPaidWages",
        page: store.state.page.page,
      })
      .then(
        (result) => {
          if (result) {
            commit("addEmployeeWageStatus", result.success);
            toast("All Good");
          } else {
            commit("addEmployeeWageStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  getPaidWageById({ commit }, payload) {
    service.getFun(`paid-wages/${payload}`).then(
      (obj) => {
        var result = obj.data;
        commit("PaidWageByIdMu", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  editPaidWage({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `paid-wages/${payload.id}`,
        null,
        {
          action: "getPaidWages",
          page: store.state.page.page,
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("editPaidWageStatus", result.success);
            toast("All Good");
          } else {
            commit("editPaidWageStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deletePaidWage({ commit, dispatch }, payload) {
    service.deleteFun(`paid-wages/${payload.payload}`).then(
      (result) => {
        if (result) {
          commit("deletePaidWageStatus", result.success);
          dispatch("getPaidWages", { isModal: false });
          toast(result.message);
        } else {
          commit("deletePaidWageStatus", false);
        }
      },
      (error) => {
        toastError(error);
      }
    );
  },
};
const mutations = {
  paidWagesListSet(state, paidWages) {
    state.paidWages = paidWages;
  },
  PaidWageByIdMu(state, paidWage) {
    state.paidWage = paidWage;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
  editPaidWageStatus(state, Status) {
    state.editStatus = Status;
  },
  deletePaidWageStatus(state, Status) {
    state.deleteStatus = Status;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
